import { render } from "./NewPostSection.vue?vue&type=template&id=dbbb3804&scoped=true"
import script from "./NewPostSection.vue?vue&type=script&lang=js"
export * from "./NewPostSection.vue?vue&type=script&lang=js"

import "./NewPostSection.vue?vue&type=style&index=0&id=dbbb3804&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbb3804"]])

export default __exports__